var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysAttachment = function SvgSysAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m13 7.657-4.728 4.905c-.579.6-1.365.938-2.184.938-.819 0-1.604-.338-2.183-.938A3.266 3.266 0 0 1 3 10.296c0-.85.325-1.665.905-2.266l4.727-4.904c.386-.401.91-.626 1.456-.626.546 0 1.07.225 1.456.626.386.4.603.944.603 1.51 0 .567-.217 1.11-.603 1.51l-4.733 4.905a1.01 1.01 0 0 1-.728.313 1.01 1.01 0 0 1-.728-.313 1.089 1.089 0 0 1-.301-.755c0-.283.108-.555.301-.755l4.368-4.526"
  })));
};
export default SvgSysAttachment;